import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  constructor(private snackBar: MatSnackBar) { }

  showSnackbar(message: string, duration: number = 2000, deleteMessage: string = null, errorMessage: string = null) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: {
        message,
        deleteMessage,
        errorMessage
      },
      duration,
      panelClass: ['custom-snackbar-class']
    });
  }
}
